import { ClientConstants, UserRole } from '@dss-libs/shared/type/common-types';

export const isUserAuthorized = (userRole: UserRole | undefined, requiredRole: UserRole): boolean => {
  if (!userRole) {
    return false;
  }
  return (
    ClientConstants.ROLES_ORDERED_ASCENDING.indexOf(userRole) >=
    ClientConstants.ROLES_ORDERED_ASCENDING.indexOf(requiredRole)
  );
};
